import React from "react";
import {Exercise} from "../content/ExerciseListContent/Exercise";

export const Hit = ({onMessage, user, hit, onSignInClick}) =>
    (
        <Exercise key={hit.id} exId={hit.id} onMessage={onMessage} user={user}
                  showDetails={false} onSignInClick={onSignInClick}/>
    );
